var YouboraObject = require('../object')
/**
 * This static class provides device detection methods.
 *
 * @class
 * @static
 * @memberof youbora
 */
var BackgroundDetector = YouboraObject.extend({
  constructor: function (plugin) {
    this.plugin = plugin
    this._reset()
  },

  startDetection: function (windowRef) {
    if (!this.isBackgroundDetectorStarted) {
      if (windowRef) this.windowObject = windowRef
      if (this.windowObject && this.windowObject.document) {
        this.isBackgroundDetectorStarted = true
        this.windowObject.document.addEventListener("visibilitychange", this._visibilityListener.bind(this))
      }
    }
  },

  stopDetection: function () {
    if (this.isBackgroundDetectorStarted) {
      this.windowObject.document.removeEventListener("visibilitychange", this._visibilityListener)
      this._reset()
    }
  },

  _reset: function () {
    this.isBackgroundDetectorStarted = false
    this.windowObject = typeof window !== 'undefined' ? window : undefined
  },

  _visibilityListener: function (e) {
    if (this.windowObject.document.visibilityState === 'hidden') { //to Background
      var settings = this.plugin.options['autoDetectBackgroundSettings']
      if (this.plugin.deviceDetector.isDesktop()) {
        if (typeof settings.desktop !== 'string') settings.desktop = '' // by default nothing
        if (settings.desktop === 'stop') {
          this._fireStop()
        } else if (settings.desktop === 'pause') {
          this._firePause()
        }
      } else if (this.plugin.deviceDetector.isAndroid()) {
        if (typeof settings.android !== 'string') settings.android = 'stop' // by default stop
        if (settings.android === 'stop') {
          this._fireStop()
        } else if (settings.android === 'pause') {
          this._firePause()
        }
      } else if (this.plugin.deviceDetector.isIphone()) {
        if (typeof settings.iphone !== 'string') settings.iphone = 'stop' // by default stop
        if (settings.iphone === 'stop') {
          this._fireStop()
        } else if (settings.iphone === 'pause') {
          this._firePause()
        }
      }
    }
  },

  _firePause: function () {
    console.log('firing pause')
    var adsAdapter = this.plugin.getAdsAdapter()
    var contentAdapter = this.plugin.getAdapter()
    if (adsAdapter && adsAdapter.flags.isStarted && !adsAdapter.flags.isEnded) {
      adsAdapter.firePause()
    } else if (contentAdapter && contentAdapter.flags.isStarted && !contentAdapter.flags.isEnded) {
      contentAdapter.firePause()
    }
  },

  _fireStop: function () {
    console.log('firing stop')
    var adsAdapter = this.plugin.getAdsAdapter()
    var contentAdapter = this.plugin.getAdapter()
    if (adsAdapter && adsAdapter.flags.isStarted && !adsAdapter.flags.isEnded) {
      adsAdapter.fireStop()
    }
    if (contentAdapter && contentAdapter.flags.isStarted && !contentAdapter.flags.isEnded) {
      contentAdapter.fireStop({ end: true })
    }
  }
})

module.exports = BackgroundDetector



//////////////////
// WEBPACK FOOTER
// ./src/detectors/backgroundDetector.js
// module id = 19
// module chunks = 0